var scrollToView = function (elem, speed) {

    var scrollTarget = elem;

    $("html,body").animate({
        scrollTop: scrollTarget.offset().top
    }, speed);

    return false;
};